import React from 'react';

import { Props } from './props';
import { AboutSiteBody, AboutSiteComponents } from './body';

// SSR専用のeager import版。index.tsx（CSR、lazy()+Suspense）と実際の画面構造は
// body.tsxを共有していて、ここでの差分は「lazy()ではなく静的importで解決する」ことだけ。
// registrations/knowledge.js（server-bundle.js経由でのみ読み込まれる）からのみ参照する。
// 理由: react-dom 17.0.2 cjs/react-dom-server.browser.development.js:3838-3847の
// `case REACT_SUSPENSE_TYPE` は中身がlazy()かどうかに関わらず<Suspense>要素そのものに
// 遭遇した時点で無条件にthrowする（「ReactDOMServer does not yet support Suspense.」
// = React error #294、実測で確認）。そのためtop-levelのeager importだけでは不十分で、
// SSR対象ツリーに<Suspense>要素が1つでも含まれていれば失敗する（KnowledgeDetail/
// index.ssr.tsxのコメント参照。かつて子コンポーネントのfooter_inquiry/view.tsxや
// KnowledgePagger、knowledge.tsx等が中身のないSuspenseラッパーを持っていたため、
// トップレベルのeager化後もSSRが失敗し続けた。issue #2141で全箇所除去済み）。
// index.tsx側はKnowledgeカード自体は1コンポーネントのみで記事本文のような
// 大量コード分割の対象を持たないため、SSR/クライアント双方をeagerにしても
// バンドルサイズへの影響は小さい（KnowledgeDetail/index.ssr.tsxのコメント参照）。
import PagePC from '@Components/pc/page/view';
import PageSP from '@Components/sp/page/view';
import Tab from '@Components/tab/view';
import Breadcrumb from '@Components/breadcrumb/view';
import FooterInquiryPC from '@Components/pc/footer_inquiry/view';
import FooterInquirySP from '@Components/sp/footer_inquiry/view';
import Faq from './components/faq';
import Knowledge from './components/knowledge';

const components: AboutSiteComponents = {
    PagePC,
    PageSP,
    Tab,
    Breadcrumb,
    FooterInquiryPC,
    FooterInquirySP,
    Faq,
    Knowledge,
};

type AboutSiteProps = Props & { currentPath?: string };

const AboutSite = (props: AboutSiteProps) => {
    return <AboutSiteBody {...props} components={components} />;
};

export default AboutSite;
